// extracted by mini-css-extract-plugin
export var breadcrumbPadding = "heroTextReduced-module--breadcrumbPadding--0adcf";
export var headlineWithSubheadline = "heroTextReduced-module--headlineWithSubheadline--61fe8";
export var headlineWithoutSubheadline = "heroTextReduced-module--headlineWithoutSubheadline--5fcc5";
export var heroTextReducedContainer = "heroTextReduced-module--heroTextReducedContainer--8ca58";
export var heroTextReducedContent = "heroTextReduced-module--heroTextReducedContent--1c463";
export var heroTextReducedGrid = "heroTextReduced-module--heroTextReducedGrid--c85c2";
export var heroTextReducedGridBlock = "heroTextReduced-module--heroTextReducedGridBlock--ba42b";
export var heroTextReducedSection = "heroTextReduced-module--heroTextReducedSection--6d902";
export var heroTextReducedTagline = "heroTextReduced-module--heroTextReducedTagline--4beb9";